<script>
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import { dateFormat } from "@/core/services/helpers"
  import { ptBR } from "vuejs-datepicker/dist/locale"
  import SeasonalityForm from "@/domains/lines/views/seasonalities/partials/SeasonalityForm.vue"
  import moment from "moment"

  export default {
    components: {
      Breadcrumbs,
      SeasonalityForm,
    },
    props: {
      id: {
        type: Number,
        required: true,
      },
    },
    data: () => {
      return {
        locale: ptBR,
        dateFormat,
        title: "Atualizar Sazonalidade",
        crumbs: [
          { name: "Início", path: "index" },
          { name: "Linhas", path: "lines.index" },
          {
            name: "Sazonalidades",
            path: "lines.seasonalities",
          },
          {
            name: "Atualizar Sazonalidade",
            path: "lines.seasonalities.edit",
          },
        ],
        seasonality: {
          desazonalidade: "",
          deinfosazonalidade: "",
          dtinicio: "",
          dtfim: "",
        },
      }
    },
    mounted() {
      this.$axios
        .get(`/api/lines/seasonality/${this.id}`)
        .then((response) => {
          this.seasonality = response.data
          this.seasonality.dtinicio = moment(this.seasonality.dtinicio).toDate()
          this.seasonality.dtfim = moment(this.seasonality.dtfim).toDate()
        })
        .catch((error) => {
          this.$toast.error({
            title: "Erro",
            message: error.response.data.error,
          })
        })
    },
    methods: {
      submit() {
        this.$axios
          .put(
            "/api/lines/seasonality/" + this.seasonality.idsazonalidade,
            this.seasonality
          )
          .then(() => {
            this.$toast.success({
              title: "OK",
              message: "Sazonalidade Atualizada com Sucesso",
            })
            this.$router.push({ name: "lines.seasonalities" })
          })
          .catch((error) => {
            this.$toast.error({
              title: "Erro",
              message: error.response.data.error,
            })
          })
      },
    },
  }
</script>
<style>
  .date-picker-seasonality > .vdp-datepicker__calendar {
    width: 100% !important;
  }
</style>

<template>
  <div class="w-full bg-white">
    <div class="px-2 my-4 sm:px-6">
      <Breadcrumbs class="mb-2" :crumbs="crumbs"/>
      <div
        class="flex flex-wrap justify-between align-baseline border-b-2 border-green-base mb-2"
      >
        <h1 class="text-green-base uppercase pt-5">Atualizar Sazonalidade</h1>
      </div>
      <SeasonalityForm :seasonality="seasonality" @submit="submit"/>
    </div>
  </div>
</template>
